<template>

  <label v-if="label" :for="id ?? name" :class="labelClasses" :aria-label="label">
    {{ label }}
  </label>

</template>


<script>

export default {
  name: "RpmInputLabel",
  inheritAttrs: false,
  computed: {
    labelClasses() {
      return [
        this.labelClass,
        this.required ? "required":"",
        this.optional ? "optional":""
      ]
    }
  },
  props: {
    label: {
      type: String,
      default: ""
    },
    id: {
      type: [String, Number],
      default: null
    },
    name: {
      type: [String, Number],
      default: null
    },
    labelClass: {
      type: String,
      default: "font-bold text-xs"
    },
    required: {
      type: Boolean,
      default: false
    },
    optional: {
      type: Boolean,
      default: false
    },
  },
};

</script>
